import { render, staticRenderFns } from "./index.vue?vue&type=template&id=83b11644"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=83b11644&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83b11644')) {
      api.createRecord('83b11644', component.options)
    } else {
      api.reload('83b11644', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=83b11644", function () {
      api.rerender('83b11644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/table/input/IkTableCheckTag/index.vue"
export default component.exports